import type { WarningNotificationRepository } from '@/domains/ui/warningNotification.repository';
import { BaseNotificationService } from './baseNotification.service';

/**
 * Servicio específico para notificaciones de advertencia usando SweetAlert2
 * Cumple con SRP: única responsabilidad es mostrar advertencias al usuario
 * Usa servicio base para eliminar duplicación de configuración
 */
class WarningNotificationService
  extends BaseNotificationService
  implements WarningNotificationRepository
{
  async showWarning(message: string): Promise<void> {
    await this.showNotification(
      message,
      BaseNotificationService.CONFIGS.WARNING,
    );
  }

  async showWarningInfo(message: string): Promise<void> {
    await this.showNotification(
      message,
      BaseNotificationService.CONFIGS.WARNING_INFO,
    );
  }
}

export const warningNotificationService = new WarningNotificationService();
